import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-limit.ts';

const modelValueType: Record<TModelValueType, string> = {
  auto: 'Auto',
  value: 'Static',
  factoredLimit: 'Dynamic',
};

export default {
  modelValueType,
};
